import gql from 'graphql-tag';

export const INFLATION_VOLATILITY_QUERY = gql`
    query ThirtyDayPRTIX($benchmarkTicker: String!) {
        mutualFund(ticker: $benchmarkTicker) {
            thirtyDayAnnualizedDividendYieldAsOfDate
            thirtyDayAnnualizedDividendYield
            unsubsidizedThirtyDaySECYieldAsOfDate
            unsubsidizedThirtyDaySECYield
            yield30DayStandard
            yield30DayStandardEffectiveDate
            inceptionDate
        }
    }
`;
